<script>
  import { layoutMethods, exportMethods } from "@/state/helpers";
  import flatPickr from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import moment from 'moment-timezone';
  import Swal from 'sweetalert2';

  import { smartRaffleMethods } from "@/state/helpers"; // Import the methods for API connection

  /**
   * Entries component
   */
  export default {
    page: {
      title: "Entries"
    },
    components: {
      flatPickr
    },
    computed: {
    },
    data() {
      return {
        title: "Entries",
        filterSKU: {
          selectedSKU: null,
          numOfEntriesReceived: 0, 
          durationDate: null,
          selectedRaffleIdentifier: null,
          selectedIsEmployee: null
        },
        skuDropdown: [],
        raffleIdentifierDropdown: [],
        employeesDropdown: [
          { value: true, text: "Include" },
          { value: false, text: "Exclude" },
        ],
        payloadData: {
          selectedSKU: null,
          startDate: null,
          endDate: null,
          isIncludePeddlrEmployees: true
        },
        entriesList: [],
        fieldsEntriesList: [
          { key: 'sku_name', sortable: true, label: 'SKU Name' },
          { key: 'total_entries', sortable: true, label: 'Total Number of Entries' }
        ],
        skuTransactionList: [],
        fieldsSkuTransactionList: [
          { key: 'transaction_id', sortable: true, label: 'Transaction ID' },
          { key: 'store_name', sortable: true, label: 'Store Name' },
          { key: 'sss_mobile_num', sortable: true, label: 'SSS Mobile Number' },
          { key: 'raffle_identifier', sortable: true, label: 'Raffle Identifier Name' },
          { key: 'promo_code', sortable: true, label: 'Promo code' },
          { key: 'no_of_entries', sortable: true, label: 'Number of Entries' },
          { key: 'network', sortable: true, label: 'Network' },
          { key: 'notify_timestamp', sortable: true, label: 'Transaction Date' },
          { key: 'transaction_amount', sortable: true, label: 'Transaction Amount' },
          { key: 'store_owner', sortable: true, label: 'Store Owner' },
          { key: 'email_address', sortable: true, label: 'Email Address' },
          { key: 'sss_address', sortable: true, label: 'SSS Address' },
          { key: 'user_id', sortable: true, label: 'Account User ID' },
          { key: 'is_employee', sortable: true, label: 'Employees' },
        ],
        searchOptions: [
          { text: 'Search All', value: null },
          { text: 'Transaction ID', value: 'eload.transaction_id' },
          { text: 'Promo Code', value: 'eload.promo_code' },
          { text: 'Store Owner', value: 'u.name' },
        ],
        employeeOptions: [
          { text: 'Include', value: true },
          { text: 'Exclude', value: false },
        ],
        searchValue: {
          searchField: null,
          searchKeyword: null,
          filterRaffleIdentifier: null,
          filterEmployee: true
        },
        skuTransactionListTotalRows: null,
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        sortBy: "eload.id",
        sortDesc: true,
        refreshPage: false,
        isSubmitted:false,
        isLoadingEntriesTable: true,
        isLoadingSkuTransactionTable: true,
        rangeOptions: {
          mode: "range",
        },
        dateToday: moment().format("YYYY-MM-DD"),
        findCurrentRafflePromo: null,
      };
    },
    methods: {
      ...layoutMethods,
      ...smartRaffleMethods,
      ...exportMethods,
      async getSkuDropdownItems() {
        // Build the payload
        let requestPayload = {
          skuName: null,
          startDate: this.payloadData.startDate,
          endDate: this.payloadData.endDate,
          isIncludePeddlrEmployees: this.payloadData.isIncludePeddlrEmployees
        }

        // Proceed with the API request
        await this.actionSmartRaffle({
            action: "entries-list",
            body: { ...requestPayload }
        }).then((res) => {
          let backendResponse = res["message"]

          if (backendResponse.statusCode == 201) {
            this.skuDropdown = []
          }
          else {
            this.skuDropdown = backendResponse.map((entry, index) => {
              // Create the list for SKU dropdown
              let mappedData = {
                value: index + '',
                text: entry.sku_name,
                totalEntries: entry.total_entries
              }

              return {
                ...mappedData,
              }
            });

          }
        }).catch((err) => {
            console.error("err", err);
        })
      },
      async getRaffleIdentiferDropdownItems() {
        await this.actionSmartRaffle({
            action: "active-raffle-identifier-list",
            body: { 
              hideExpiredPromo: false
            }
        }).then((res) => {
            this.raffleIdentifierDropdown = res["message"].map(raffle => {
              return { 
                ...raffle,
                raffleStartDate: raffle.raffleStartDate,
                raffleEndDate: raffle.raffleEndDate,
                value: raffle.raffleIdentifierId,
                text: raffle.raffleIdentifierName
              }
            });

            // Find the on-going Raffle Promo for today's date, then select it by default in the dropdown
            this.checkChangedValue('selectedRaffleIdentifier');
            this.filterSKU.selectedRaffleIdentifier = this.findCurrentRafflePromo ? this.findCurrentRafflePromo.raffleIdentifierId : null
            this.searchValue.filterRaffleIdentifier = this.findCurrentRafflePromo ? this.findCurrentRafflePromo.raffleIdentifierId : null


            // Display the contents of the table, based on fetched Raffle Start/End Date
            this.getEntriesList();
            this.getSkuTransactionList();
            
        }).catch((err) => {
            console.error("err", err);
        })
      },
      onFilter() {
        this.isSubmitted = true

        // Lookup the values that will be used in payload
        let lookupSkuData = null,
            dates = null,
            startDate = null,
            endDate = null;

        if (this.filterSKU.selectedSKU) {
          lookupSkuData = this.skuDropdown.find(x => 
            x.value == this.filterSKU.selectedSKU
          )
        }
        if (this.filterSKU.durationDate) {
          dates = this.filterSKU.durationDate.split(' to '),
          startDate = dates[0] || '',
          endDate = dates[1] || '';
        }
        if (this.filterSKU.selectedRaffleIdentifier) {
          // Find the details of selected Raffle Promo, then set it in the request payload
          let raffleDetails = this.raffleIdentifierDropdown.find(x => 
            x.raffleIdentifierId == this.filterSKU.selectedRaffleIdentifier
          )

          if (raffleDetails) {
            startDate = raffleDetails.raffleStartDate
            endDate = raffleDetails.raffleEndDate
          }
        }

        this.payloadData.selectedSKU = this.filterSKU.selectedSKU ? lookupSkuData.text : null
        this.payloadData.startDate = startDate ? startDate : null
        this.payloadData.endDate = endDate ? endDate : null
        this.payloadData.isIncludePeddlrEmployees = this.isEmpty(this.filterSKU.selectedIsEmployee) ? true : this.isEmpty(this.filterSKU.selectedIsEmployee)

        this.getSkuDropdownItems();
        this.getEntriesList();
      },
      async getEntriesList() {
        // Build the payload
        let requestPayload = {
          skuName: this.payloadData.selectedSKU,
          startDate: this.payloadData.startDate,
          endDate: this.payloadData.endDate,
          isIncludePeddlrEmployees: this.payloadData.isIncludePeddlrEmployees
        }

        // Proceed with the API request
        await this.actionSmartRaffle({
            action: "entries-list",
            body: { ...requestPayload }
        }).then((res) => {
            this.isLoadingEntriesTable = false
            this.isSubmitted = false
            let backendResponse = res["message"]

            if (backendResponse.statusCode == 201) {
              this.entriesList = []
            }
            else {
              this.entriesList = backendResponse
            }
        }).catch((err) => {
            console.error("err", err);
        })
      },
      async getSkuTransactionList() {
        let requestPayload = {
          page: this.currentPage,
          rows: this.refreshPage ? 10 : this.perPage,
          sort: this.refreshPage ? "id" : this.sortBy,
          sortDesc: this.refreshPage ? false : this.sortDesc,

          searchField: this.refreshPage ? "" : this.searchValue.searchField,
          searchKeyword: this.refreshPage ? "" : this.searchValue.searchKeyword,
          filterRaffleIdentifier: this.searchValue.filterRaffleIdentifier,
          isIncludePeddlrEmployees: this.searchValue.filterEmployee
        }

        await this.actionSmartRaffle({
            action: "sku-transactions-list",
            body: { ...requestPayload }
        }).then((res) => {
            this.isLoadingSkuTransactionTable = false
            let responseData = res["message"]

            if (responseData.statusCode == 201) {
              this.skuTransactionListTotalRows = 0
              this.skuTransactionList = [];
            }
            else {
              // this.skuTransactionList = res["message"]["rows"]
              this.skuTransactionListTotalRows = responseData["pageInfo"]["total"]
  
              // Map the fields, to display the correct format
              this.skuTransactionList = responseData["rows"].map(skuData => { 
                skuData.raffle_identifier = this.isEmpty(skuData.raffle_identifier) ? "--" : skuData.raffle_identifier
                skuData.sss_mobile_num = this.isEmpty(skuData.sss_mobile_num) ? "--" : skuData.sss_mobile_num
                skuData.email_address = this.isEmpty(skuData.email_address) ? "--" : skuData.email_address
                skuData.sss_address = this.isEmpty(skuData.sss_address) ? "--" : skuData.sss_address
                skuData.notify_timestamp = moment(skuData.notify_timestamp).format("MMM DD, YYYY hh:mm A")
  
                return { 
                  ...skuData,
                }
              });
            }

            this.refreshPage = false;
        }).catch((err) => {
            console.error("err", err);
        })
      },
      isEmpty(value){
        return (
        // null or undefined
        (typeof value == "undefined") || 
        (value == undefined) ||
        (value == null) ||
        (value === "") ||
        // has length and it's zero
        (Object.prototype.hasOwnProperty.call(value,'length') && value.length === 0) ||
        // is an Object and has no keys
        (value.constructor === Object && Object.keys(value).length === 0)
        )
      },
      checkChangedValue(data) {
        switch (data) {
          case "selectedSKU": {
            let findData = this.skuDropdown.find(x => 
              x.value == this.filterSKU.selectedSKU
            )

            this.filterSKU.numOfEntriesReceived = findData.totalEntries
            break;
          }

          case "selectedRaffleIdentifier": {
            this.findCurrentRafflePromo = this.raffleIdentifierDropdown.find(x => 
              moment(this.dateToday) >= moment(x.raffleStartDate) && 
              moment(this.dateToday) <= moment(x.raffleEndDate)
            )

            this.skuDropdown = []
            this.filterSKU.selectedSKU = null
            this.filterSKU.durationDate = null
            this.payloadData.startDate = this.findCurrentRafflePromo ? this.findCurrentRafflePromo.raffleStartDate : null
            this.payloadData.endDate = this.findCurrentRafflePromo ? this.findCurrentRafflePromo.raffleEndDate : null
            break;
          }

          case "durationDate": {
            let element = document.getElementById("date-duration-date");
            // this.raffleDetails.promoDuration = element.value

            if (!this.isEmpty(element.value)) {
              this.filterSKU.selectedRaffleIdentifier = null
            }
            break;
          }
        
          default:
            break;
        }
      },
      tableSorting(action) {
        switch (action.sortBy) {
          case 'transaction_id':
            this.sortBy = 'eload.transaction_id';
            break;
          case 'store_name':
            this.sortBy = 'store_name';
            break;
          case 'sss_mobile_num':
            this.sortBy = 'sss_mobile_num';
            break;
          case 'raffle_identifier':
            this.sortBy = 'raffle_identifier';
            break;
          case 'promo_code':
            this.sortBy = 'eload.promo_code';
            break;
          case 'no_of_entries':
            this.sortBy = 'eload.no_of_entries';
            break;
          case 'network':
            this.sortBy = 'eload.network';
            break;
          case 'notify_timestamp':
            this.sortBy = 'eload.notify_timestamp';
            break;
          case 'transaction_amount':
            this.sortBy = 'eload.transaction_amount';
            break;
          case 'store_owner':
            this.sortBy = 'store_owner';
            break;
          case 'email_address':
            this.sortBy = 'email_address';
            break;
          case 'sss_address':
            this.sortBy = 'sss_address';
            break;
          case 'user_id':
            this.sortBy = 'eload.user_id';
            break;
        }

        this.sortDesc = action.sortDesc;
        this.getSkuTransactionList();
      },
      async onPageUpdate(reset = false) {
        if (this.searchValue.searchKeyword) {
          this.currentPage = (reset ? 1 : this.currentPage);
        }

        this.getSkuTransactionList();
      },
      async onExport(){
        if(this.skuTransactionListTotalRows ==0){
          Swal.fire("Failed!", "No data to export.", "warning");
          return;
        }
        let params = Object.assign(
          {
            module: 'smart_raffle_entries',
            email: JSON.parse(localStorage.getItem('userData')).email,
            search: this.searchValue.searchKeyword ? this.searchValue.searchKeyword : null,
            searchField: this.searchValue.searchField ? this.searchValue.searchField : null,
            orderDesc: this.sortDesc,
            sort: this.sortBy,
            filterRaffleIdentifier: this.searchValue.filterRaffleIdentifier,
            isIncludePeddlrEmployees: this.searchValue.filterEmployee
          });

        
        this.exportReport(params)
          .then(() => Swal.fire("Success!", `Your request for reports is pending. It will be sent to your email once it's ready.`, "success"))
          .catch(() => Swal.fire("Failed!", `Your request for reports has failed.`, "warning"));
      },
    },
    async mounted(){
      this.getSkuDropdownItems();
      this.getRaffleIdentiferDropdownItems();
      // this.getEntriesList();
      // this.getSkuTransactionList();
    }
  }
    
</script>



<template>
  <div class="row"><!-- outer div-->
    <div class="col-md-5 col-12"> <!-- start of Filter SKU main div -->
      <div class="card">
        <div class="card-header text-dark fw-bold">
          Filter SKU
        </div>
        <div class="card-body">

          <div class="col-md-12">
            <label>Select SKU</label>
            <template>
              <b-form-select v-model="filterSKU.selectedSKU" 
                             :options="skuDropdown" 
                             class="form-select shadow-none"
                             @change="checkChangedValue('selectedSKU')">
                <template #first>
                  <b-form-select-option :value="null">
                    Search All
                  </b-form-select-option>
                </template>
              </b-form-select>
            </template>
          </div> <!-- End of selectedSKU field -->

          <div class="col-md-12 mt-4">
            <label>Total Number of Entries Received: {{ filterSKU.numOfEntriesReceived }}</label>
          </div> <!-- End of numOfEntriesReceived field -->

          <div class="col-md-12 mt-3">
            <label>Select Raffle Identifier</label>
            <template>
              <b-form-select v-model="filterSKU.selectedRaffleIdentifier" 
                             :options="raffleIdentifierDropdown" 
                             class="form-select shadow-none"
                             @change="checkChangedValue('selectedRaffleIdentifier')">
                <template #first>
                  <b-form-select-option :value="null">
                    Search All
                  </b-form-select-option>
                </template>
              </b-form-select>
            </template>
          </div> <!-- End of selectedRaffleIdentifier field -->

          <div class="col-md-12 mt-3">
            <label class="form-label">Duration Date</label>
            <flat-pickr placeholder="Select a date range"
                        v-model="filterSKU.durationDate"
                        :config="rangeOptions"
                        @on-change="checkChangedValue('durationDate')"
                        id="date-duration-date"
                        class="form-control"
            ></flat-pickr>
          </div> <!-- End of durationDate field -->

          <div class="col-md-12 mt-3">
            <label>Employees</label>
            <template>
              <b-form-select v-model="filterSKU.selectedIsEmployee" 
                             :options="employeesDropdown" 
                             class="form-select shadow-none"
                             @change="checkChangedValue('selectedIsEmployee')">
                <template #first>
                  <b-form-select-option :value="null" 
                                        disabled>
                    Select Employee View
                  </b-form-select-option>
                </template>
              </b-form-select>
            </template>
          </div> <!-- End of selectedIsEmployee field -->

          <div class="mt-4">
            <b-button class="w-100"
                      type="submit"
                      variant="primary"
                      :disabled="isSubmitted"
                      @click="onFilter">
              <span v-if="isSubmitted"
                    class="spinner-grow spinner-grow-sm"
                    role="status"
                    aria-hidden="true"
              ></span>
              Filter
            </b-button>
          </div> <!-- End of FILTER button -->

        </div>
      </div>
    </div> <!-- end of Filter SKU main div -->


    <div class="col-md-7 col-12"> <!-- start of List of Entries main div -->
      <div class="card">
        <div class="card-header text-dark fw-bold">
          List of Entries
        </div>
        <div class="card-body">
          <div class="table-responsive mb-0"> <!-- start of List of Entries data-table -->
            <div class="table align-middle table-nowrap">
              <b-table :items="entriesList"
                       :fields="fieldsEntriesList"
                       responsive="sm"
                       class="table-check">

                <template #cell(sku_name)="data">
                  <span>{{ data.item.sku_name }}</span>
                </template>

                <template #cell(total_entries)="data">
                  <p class="text-body m-0 ">{{ data.item.total_entries }}</p>
                </template>

              </b-table>
            </div>
          </div> <!-- end of List of Entries data-table -->

          <div class="row g-0 mb-1 text-center" v-if="isLoadingEntriesTable">
            <span>Loading data...</span>
          </div>
          <div class="row g-0 text-center" v-if="!isLoadingEntriesTable && entriesList.length == 0">
            <span>No data to display.</span>
          </div>

        </div>
      </div>
    </div> <!-- end of List of Entries main div -->


    <div class="col-md-12 col-12 mt-3"> <!-- start of SKU Transaction main div -->
      <div class="card">
        <div class="card-header text-dark fw-bold">
          SKU Transaction ({{ skuTransactionListTotalRows }})
        </div>
        <div class="card-body">

          <div class="row"> <!-- start of search and filter bar -->
            <div class="header-container">
              <div class="filter-items">
                <div class="me-3">
                  <form class="d-flex" @submit.prevent="onPageUpdate()">
                    <b-form-group id="input-group-3" label-for="input-3">
                      <b-form-select v-model="searchValue.searchField" 
                                     :options="searchOptions"
                                     class="form-select rounded-0 rounded-start shadow-none w-200px" 
                                     id="input-3">
                      </b-form-select>
                    </b-form-group>

                    <b-form-group id="input-group-3" class="text-align-right" label-for="input-3">
                      <template v-slot:description>
                        <div class="d-flex justify-content-end" style="margin-top: 2px">
                          Search Keyword
                        </div>
                      </template>
                      <b-form-input id="input-keyword" 
                                    v-model="searchValue.searchKeyword" 
                                    class="rounded-0 rounded-end" 
                                    style="width: auto"></b-form-input>
                    </b-form-group>
                  </form>
                </div>
              </div>

              <div class="me-3 ta-right">
                <b-form-group label-for="filter-raffle-identifier"
                              description="Filter by Raffle Identifier"
                              class="text-align-right">
                  <b-form-select v-model="searchValue.filterRaffleIdentifier" 
                                 :options="raffleIdentifierDropdown"
                                 class="form-select rounded-2 shadow-none w-200px" 
                                 id="filter-raffle-identifier">
                    <template #first>
                      <b-form-select-option :value="null">
                        All
                      </b-form-select-option>
                    </template>
                  </b-form-select>
                </b-form-group>
              </div> <!-- End of filterRaffleIdentifier filter -->

              <div class="me-3 ta-right">
                <b-form-group label-for="filter-employee"
                              description="Filter by Employee"
                              class="text-align-right">
                  <b-form-select v-model="searchValue.filterEmployee" 
                                 :options="employeesDropdown"
                                 class="form-select rounded-2 shadow-none w-200px" 
                                 id="filter-employee">
                  </b-form-select>
                </b-form-group>
              </div> <!-- End of filterEmployee filter -->

              <div class="search-btn me-3">
                <b-form-group label="">
                  <b-button variant="primary" type="button" @click="onPageUpdate(true)" class="px-2">
                    <i class='bx bx-search bx-fw'></i>
                    Search
                  </b-button>
                </b-form-group>
              </div> <!-- End of Search button -->

              <div class="export-btn float-end">
                <b-form-group label="">
                  <a href="javascript:void(0);" class="btn btn-primary me-2" @click="onExport">
                    <i class="uil uil-export me-1"></i>Export
                  </a>
                </b-form-group>
              </div> <!-- End of Export button -->
              

            </div>
          </div> <!-- end of search and filter bar -->


          <div class="table-responsive mt-3"> <!-- start of SKU Transaction data-table -->
            <div class="table align-middle table-nowrap">
              <b-table :items="skuTransactionList"
                       :fields="fieldsSkuTransactionList"
                       responsive="sm"
                       class="table-check"
                       :current-page="currentPage"
                       @sort-changed="tableSorting"
                       :sort-by.sync="sortBy" 
                       :sort-desc.sync="sortDesc">

                <!-- <template #cell(transactionId)="data">
                  <span>{{ data.item.transactionId }}</span>
                </template> -->

                <template #cell(sss_address)="data">
                  <span :title="data.item.sss_address">
                    {{ data.item.sss_address | truncator(30,"...") }}
                  </span>
                </template>

                <template #cell(is_employee)="data">
                  <span>{{ data.item.is_employee ? "Employee" : "Not Employee" }}</span>
                </template>

              </b-table>
            </div>
          </div> <!-- end of SKU Transaction data-table -->

          <div class="row g-0 mb-1 text-center" v-if="isLoadingSkuTransactionTable">
            <span>Loading data...</span>
          </div>
          <div class="row g-0 text-center" v-if="!isLoadingSkuTransactionTable && skuTransactionList.length == 0">
            <span>No data to display.</span>
          </div>

          <div class="col-sm-12"> <!-- start of table footer (Display #, and Pagination) -->
            <div class="row mt-2">
              <div class="col">
                <div class="form-group row pull-left" v-if="skuTransactionListTotalRows > 10">
                  <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                  <div class="col-sm-6">
                    <b-form-group label-for="display-record">
                      <b-form-select class="form-select shadow-none w-fit" 
                                     id="display-record" 
                                     v-model="perPage"
                                    :options="pageOptions" 
                                    @change="getSkuTransactionList()"
                      ></b-form-select>
                    </b-form-group>
                  </div>
                </div>
                <div class="dataTables_paginate paging_simple_numbers float-end"  v-if="skuTransactionListTotalRows > perPage">
                  <!-- pagination -->
                  <b-pagination class="pagination-rounded" 
                                v-model="currentPage" 
                                :total-rows="skuTransactionListTotalRows"
                                @input="onPageUpdate()" 
                                :per-page="perPage"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div> <!-- end of table footer (Display #, and Pagination) -->

        </div>
      </div>
    </div> <!-- end of SKU Transaction main div -->
  </div> <!-- end of outer div-->
</template>



<style>
  .header-container {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding-right: 0;

    .search-btn {
      flex: 1;
    }
  }
</style>